import { useActiveBrandConfig } from '@/brand';

export const usePageTitle = (pageTitle: string) => {
  const { name } = useActiveBrandConfig();
  return `${pageTitle} | ${name}`;
};
